// ModalContext.tsx
import { createContext, useContext, useState } from "react";

interface ModalContextType {
  isAnyModalOpen: boolean;
  setIsAnyModalOpen: (value: boolean) => void; // ✅ expose setter
}

const ModalContext = createContext<ModalContextType>({
  isAnyModalOpen: false,
  setIsAnyModalOpen: () => {},
});

export const ModalProvider = ({ children }: { children: React.ReactNode }) => {
  const [isAnyModalOpen, setIsAnyModalOpen] = useState(false);

  return (
    <ModalContext.Provider
      value={{
        isAnyModalOpen,
        setIsAnyModalOpen,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export const useModalContext = () => useContext(ModalContext);
